// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"9f531c65a8eb92111d67","293":"5722cd0996aff1bb6531","518":"e1318e8aae34fdd676a7","779":"bdf100f3c08a0f8f02b7"}[chunkId] + ".js";
};